(() => {
  const i18n = window.CoffeaI18n;
  const panel = document.getElementById('CartPanel');
  if (!panel || typeof panel.showModal !== 'function') return;
  const root = window.Shopify?.routes?.root || '/';
  const status = panel.querySelector('.cart-panel__status');
  const items = panel.querySelector('.cart-panel__items');
  let busy = false;
  let returnFocus;
  let currentCart;
  const money = (amount, currency) => new Intl.NumberFormat(document.documentElement.lang === 'en' ? 'en-US' : 'es-CO', {
    style: 'currency', currency, maximumFractionDigits: 0,
  }).format(amount / 100);
  const element = (tag, text, className) => {
    const node = document.createElement(tag);
    if (text !== undefined) node.textContent = text;
    if (className) node.className = className;
    return node;
  };
  async function request(path, body) {
    const response = await fetch(root + path, {
      method: body ? 'POST' : 'GET',
      headers: { Accept: 'application/json', ...(body && !(body instanceof FormData) ? { 'Content-Type': 'application/json' } : {}) },
      ...(body ? { body: body instanceof FormData ? body : JSON.stringify(body) } : {}),
    });
    const data = await response.json();
    if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : i18n.cart_0);
    return data;
  }
  function counts(cart) {
    document.querySelectorAll('.cart-pill strong').forEach(node => node.textContent = cart.item_count);
  }
  function render(cart) {
    currentCart = cart;
    window.CoffeaCartNotes?.update(cart);
    counts(cart);
    items.replaceChildren();
    cart.items.forEach(item => {
      const row = element('article', undefined, 'cart-panel__item');
      const heading = element('h3');
      const link = element('a', item.product_title);
      link.href = item.url;
      heading.append(link);
      row.append(heading, element('p', money(item.final_line_price, cart.currency)));
      if (item.variant_title && item.variant_title !== 'Default Title') row.append(element('p', item.variant_title));
      Object.entries(item.properties || {}).forEach(([key, value]) => {
        if (!key.startsWith('_') && value) row.append(element('p', `${key}: ${value}`));
      });
      const controls = element('div', undefined, 'cart-panel__controls');
      const control = (label, quantity, accessible, remove = false) => {
        const button = element('button', label);
        button.type = 'button';
        button.dataset.key = item.key;
        button.dataset.quantity = quantity;
        button.setAttribute('aria-label', accessible);
        if (remove) button.dataset.remove = '';
        return button;
      };
      const quantity = element('span', item.quantity);
      quantity.setAttribute('aria-label', `${i18n.quantity}: ${item.quantity}`);
      controls.append(control('−', item.quantity - 1, `${i18n.decrease} ${item.product_title}`), quantity,
        control('+', item.quantity + 1, `${i18n.increase} ${item.product_title}`),
        control(i18n.cart_1, 0, `${i18n.cart_1} ${item.product_title}`, true));
      row.append(controls);
      items.append(row);
    });
    if (!cart.items.length) items.append(element('p', i18n.cart_2, 'cart-panel__empty'));
    panel.querySelector('[data-cart-total]').textContent = money(cart.total_price, cart.currency);
    panel.querySelector('[data-cart-checkout]').disabled = !cart.item_count;
  }
  function open(trigger, message) {
    status.textContent = message || '';
    if (!panel.open) {
      returnFocus = trigger || document.activeElement;
      panel.showModal();
      document.documentElement.classList.add('cart-panel-open');
    }
  }
  function lock(value) {
    busy = value;
    panel.setAttribute('aria-busy', String(value));
    panel.querySelectorAll('[data-key], [data-cart-checkout]').forEach(button => {
      button.disabled = value || (button.hasAttribute('data-cart-checkout') && !currentCart?.item_count);
    });
  }
  function toast(message) {
    const node = document.querySelector('.coffea-toast');
    if (!node) return;
    node.textContent = message;
    node.classList.add('show');
    clearTimeout(window.coffeaToastTimer);
    window.coffeaToastTimer = setTimeout(() => node.classList.remove('show'), 5000);
  }
  panel.addEventListener('close', () => {
    document.documentElement.classList.remove('cart-panel-open');
    if (returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
  });
  panel.addEventListener('click', async event => {
    if (event.target.closest('[data-cart-close]')) { panel.close(); return; }
    if (event.target === panel) {
      const rect = panel.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) panel.close();
      return;
    }
    const button = event.target.closest('[data-key]');
    if (!button || busy) return;
    const key = button.dataset.key;
    const quantity = Number(button.dataset.quantity);
    const action = button.hasAttribute('data-remove') ? 'remove' : button.textContent;
    lock(true);
    status.textContent = quantity ? i18n.cart_3 : i18n.cart_4;
    try {
      render(await request('cart/change.js', { id: key, quantity }));
      status.textContent = quantity ? i18n.cart_5 : i18n.cart_6;
      const next = [...items.querySelectorAll('[data-key]')].find(node => node.dataset.key === key && (action === 'remove' ? node.hasAttribute('data-remove') : node.textContent === action));
      lock(false);
      (next || panel.querySelector('[data-cart-close]')).focus({ preventScroll: true });
    } catch (error) { status.textContent = error.message; }
    finally { lock(false); }
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-quick-add-form], .purchase-form');
    if (!form) return;
    event.preventDefault();
    const button = event.submitter || form.querySelector('button[type="submit"]');
    if (busy || button?.disabled) return;
    const body = new FormData(form);
    lock(true);
    if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
    let added = false;
    try {
      await request('cart/add.js', body);
      added = true;
      render(await request('cart.js'));
      open(button, i18n.cart_7);
    } catch (error) {
      // Once add succeeded, never invite a retry that could duplicate the item.
      if (added) window.location.assign(root + 'cart');
      else toast(error.message);
    } finally {
      lock(false);
      if (button) { button.disabled = false; button.removeAttribute('aria-busy'); }
    }
  });
  document.addEventListener('click', async event => {
    const link = event.target.closest('.cart-pill, .cart-remove');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
    const cartPage = document.querySelector('[data-cart-section]');
    if (link.matches('.cart-pill') && cartPage) return;
    if (link.matches('.cart-remove') && !cartPage) return;
    event.preventDefault();
    if (busy) return;
    lock(true);
    try {
      if (link.matches('.cart-pill')) {
        render(await request('cart.js'));
        open(link);
      } else {
        const url = new URL(link.href);
        const key = url.searchParams.get('id');
        if (!key) { window.location.assign(link.href); return; }
        const section = cartPage.dataset.cartSection;
        const note = cartPage.querySelector('[name="note"]')?.value;
        cartPage.setAttribute('aria-busy', 'true');
        link.textContent = 'Quitando…';
        const cart = await request('cart/update.js', { updates: { [key]: 0 }, ...(note !== undefined ? { note } : {}), sections: [section], sections_url: root + 'cart' });
        counts(cart);
        const html = cart.sections?.[section];
        const replacement = html && new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-section]');
        if (!replacement) { window.location.assign(root + 'cart'); return; }
        cartPage.replaceWith(replacement);
        window.CoffeaCartNotes?.update(cart);
        replacement.querySelectorAll('.soft-reveal,.motion-reveal').forEach(node => node.classList.add('is-in-view'));
        const focus = replacement.querySelector('.cart-remove, .cart-empty a, h1');
        if (focus) { if (focus.tagName === 'H1') focus.tabIndex = -1; focus.focus({ preventScroll: true }); }
        toast(i18n.cart_6);
      }
    } catch (error) {
      if (link.matches('.cart-remove')) link.textContent = i18n.cart_1;
      toast(error.message);
    } finally {
      cartPage?.removeAttribute('aria-busy');
      lock(false);
    }
  });
  // Keep native forms and the existing quick-add handler as fallbacks if this asset fails to load.
  window.coffeaCartReady = true;
})();


